import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

import { Clear as ClearIcon, Search as SearchIcon } from '@mui/icons-material';
import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  useTheme,
} from '@mui/material';

import CustomButton from 'components/Button';
import { projectFilterActions } from 'features/Project/projectSlice';
import { PROJECT_STATUS } from 'utils/constants';

interface ProjectListSideOptionsProps {
  showModal: () => void;
}

/**
 *
 * @param showModal: To open Add job modal
 * @returns  Side Panel Options for Project List View
 */
const ProjectBoardSideOptions = ({ showModal }: ProjectListSideOptionsProps) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState('');

  const { projectStatus, assignee, jobAssigneeList } = useSelector((state: RootState) => state.projectFilterReducer);

  const assigneeListAll = [{ user_id: 'All', full_name: 'All', user_role: 'A' }, ...(jobAssigneeList || [])];

  return (
    <>
      <FormControl sx={{ my: 2 }}>
        <OutlinedInput
          value={searchText}
          data-testid="proj-search-job"
          onChange={(event) => setSearchText(event.target.value)}
          placeholder="Search Job"
          endAdornment={
            <InputAdornment position="end">
              {searchText ? (
                <IconButton onClick={() => setSearchText('')} edge="end">
                  <ClearIcon />
                </IconButton>
              ) : (
                <SearchIcon />
              )}
            </InputAdornment>
          }
          sx={{
            height: '32px',
            mb: theme.spacing(2),
          }}
        />
      </FormControl>

      <Box sx={{ my: 1 }}>
        <Typography variant="body2">ASSIGNEE</Typography>
        <Select
          sx={{
            height: '32px',
            width: '100%',
          }}
          data-testid="proj-select-assignee"
          onChange={(selectedItem) => {
            dispatch(projectFilterActions.setAssignee(selectedItem.target.value));
          }}
          value={assignee}>
          {Object.entries(assigneeListAll).map(([key, value]) => (
            <MenuItem key={key} value={value.user_id}>
              {value.full_name}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Box sx={{ my: 1 }}>
        <Typography variant="body2">PROJECT STATUS</Typography>
        <Select
          sx={{
            height: '32px',
            width: '100%',
          }}
          data-testid="proj-select-status"
          onChange={(selectedItem) => {
            dispatch(projectFilterActions.setProjectStatus(selectedItem.target.value));
          }}
          value={projectStatus}>
          {Object.entries(PROJECT_STATUS).map(([key, value]) => (
            <MenuItem key={key} value={value.value}>
              {value.name}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Box sx={{ my: 1, display: 'flex', justifyContent: 'flex-end' }}>
        <CustomButton
          width="medium"
          text="Add Task"
          variant="contained"
          testid={'proj-add-task-btn'}
          onClick={showModal}
        />
      </Box>
    </>
  );
};

export default ProjectBoardSideOptions;
